import React, {useEffect, useState} from "react";
import restService from "../../../../services/restService";
import Input from "../../../../components/common/Input";

const keys = ["rate", "destination_currency", "source_currency"];
const UpdateRate = ({rate, onSubmit, initCallback, setRateToUpdate}) => {

  const [form, setForm] = useState(rate);
  const [errors, setErrors] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [agents, setAgents] = useState([]);

  const initFormValues = async () => {

    const countryList = await restService.UtilsApi.getCountries();
    const currencies = countryList?.data?.data?.map((c) => {
      return c.currency_code;
    });
    setCurrencies(currencies);
  };

  useEffect(() => {
    initFormValues();
  }, []);

  const validateForm = () => {
    let errorList = {...errors};
    keys.forEach((key) => {
      if (!form[key]) {
        errorList[key] = "This field is required.";
      }

      if (key === "rate" && form.rate && form.rate <= 0) {
        errorList.rate = "Enter a number greater than 0";
      }
    });
    setErrors(errorList);
    return Object.keys(errorList).length === 0;
  };

  const saveRate = () => {
    if (validateForm()) {
      restService.RatesApi.updateRate(form).then((response) => {
        onSubmit();
      });
    }
  };

  const onFormChange = ({target}) => {
    let details = {...form};
    details[target.name] = target.value;

    if (target.name === "agency_id") {
      restService.AgentApi.getAgentsByAgency(target.value).then(({data}) => {
        setAgents(data?.data.data);
        setForm({...details, agent_id: data?.data?.data[0]?.id});
      });
      let errorList = {...errors};
      delete errorList["agent_id"];
    }
    setForm(details);

    let errorList = errors;
    delete errorList[target.name];
    setErrors(errorList);
  };
  useEffect(() => {
    initCallback(saveRate);
  }, [form]);

  return (


    <div className="flex intro-y flex-col items-center md:gap-11 gap-6 justify-center py-10 px-10">
      <div className="flex items-start justify-between w-full">
        <div className="flex items-center flex-col gap-1 justify-center w-full">
          <h1 className="text-xl font-medium text-[#0042C6]">Update Rate</h1>
          <p className="text-xs text-[#727681]">
            Please enter the rate details
          </p>
        </div>

        <span
          onClick={() => setRateToUpdate(undefined)}
          className="btn border-none"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.8337 1.34199L10.6587 0.166992L6.00033 4.82533L1.34199 0.166992L0.166992 1.34199L4.82533 6.00033L0.166992 10.6587L1.34199 11.8337L6.00033 7.17533L10.6587 11.8337L11.8337 10.6587L7.17533 6.00033L11.8337 1.34199Z"
              fill="black"
            />
          </svg>
        </span>
      </div>

      {/* Modern Form Section */}
      <div className="w-full max-w-2xl bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-6 border border-gray-200 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-white rounded-lg shadow-sm">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-gray-600">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
          <h3 className="text-lg font-bold text-gray-800">Rate Configuration</h3>
        </div>

        <div className="grid md:grid-cols-2 gap-6 grid-cols-1">
          <div className="flex flex-col gap-2">
            <label className="font-semibold text-gray-700 text-sm flex items-center gap-1">
              Exchange Rate <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              step="0.0001"
              min="0"
              placeholder="e.g., 2.3456"
              value={form.rate || ""}
              onChange={onFormChange}
              name="rate"
              className={`px-4 py-3 border rounded-xl text-sm transition-all bg-white shadow-sm focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 ${errors.rate ? 'border-red-400 ring-2 ring-red-100' : 'border-gray-200'}`}
            />
            {errors.rate && (
              <span className="text-red-500 text-xs font-semibold mt-1 flex items-center gap-1">
                <span>⚠</span> {errors.rate}
              </span>
            )}
          </div>

          <div></div> {/* Empty space for better layout */}

          <div className="flex flex-col gap-2">
            <label className="font-semibold text-gray-700 text-sm flex items-center gap-1">
              Source Currency <span className="text-red-500">*</span>
            </label>
            <select
              value={form.source_currency || ""}
              onChange={onFormChange}
              name="source_currency"
              className={`px-4 py-3 border rounded-xl text-sm transition-all bg-white shadow-sm cursor-pointer focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 ${errors.source_currency ? 'border-red-400 ring-2 ring-red-100' : 'border-gray-200'}`}
            >
              <option value="">Select source currency</option>
              {currencies.map((currency) => (
                <option key={currency} value={currency}>{currency}</option>
              ))}
            </select>
            {errors.source_currency && (
              <span className="text-red-500 text-xs font-semibold mt-1 flex items-center gap-1">
                <span>⚠</span> {errors.source_currency}
              </span>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <label className="font-semibold text-gray-700 text-sm flex items-center gap-1">
              Destination Currency <span className="text-red-500">*</span>
            </label>
            <select
              value={form.destination_currency || ""}
              onChange={onFormChange}
              name="destination_currency"
              className={`px-4 py-3 border rounded-xl text-sm transition-all bg-white shadow-sm cursor-pointer focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 ${errors.destination_currency ? 'border-red-400 ring-2 ring-red-100' : 'border-gray-200'}`}
            >
              <option value="">Select destination currency</option>
              {currencies.map((currency) => (
                <option key={currency} value={currency}>{currency}</option>
              ))}
            </select>
            {errors.destination_currency && (
              <span className="text-red-500 text-xs font-semibold mt-1 flex items-center gap-1">
                <span>⚠</span> {errors.destination_currency}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Modern Action Buttons */}
      <div className="flex items-center gap-4">
        <button
          onClick={() => setRateToUpdate(undefined)}
          className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-md flex items-center gap-2"
        >
          Cancel
        </button>
        <button
          onClick={() => saveRate(form)}
          className="px-6 py-3 rounded-xl font-semibold text-sm cursor-pointer transition-all border-none bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-700 hover:to-indigo-700 shadow-lg flex items-center gap-2"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <path d="M22 4 12 14.01l-3-3" />
          </svg>
          Update Rate
        </button>
      </div>
    </div>
  );
};

export default UpdateRate;
